var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "home",
    attrs: {
      "element-loading-background": "transparent"
    }
  }, [_c('Header'), _c('div', {
    staticClass: "content mincont"
  }, [_c('div', [_vm.isNodata ? _c('div', {
    staticClass: "norecord"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/no_record.png")
    }
  }), _c('span', [_vm._v("暂无数据")])]) : _vm._e(), _c('ul', {
    staticClass: "material-list"
  }, _vm._l(_vm.recommendList, function (list, key) {
    return _c('li', {
      key: key
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: list.listImagePath.sourceUrl,
        expression: "list.listImagePath.sourceUrl"
      }]
    }), _c('div', {
      staticClass: "pag"
    }, [_vm._v(_vm._s(list.productName))]), _c('div', {
      staticClass: "intro"
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.goDetails(list.id);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont iconchanpinjieshao"
    }), _vm._v("产品介绍 ")]), _c('em', {
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.getProductSize(list.id, list.productName);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont iconxinzeng"
    }), _vm._v("选择尺寸 ")])])]);
  }), 0), _vm.totalnumber > 10 ? _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-sizes": [10, 20, 50],
      "page-size": 10,
      "total": _vm.totalnumber,
      "layout": "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentpage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentpage = $event;
      },
      "size-change": function sizeChange($event) {
        return _vm.handleSizeChange($event);
      },
      "current-change": function currentChange($event) {
        return _vm.handleCurrentChange($event);
      }
    }
  })], 1) : _vm._e()])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('div', {
    staticClass: "next"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("上一步")]), _c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步(2/3)")])]), _c('Footer'), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "800px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "nature"
  }, [_c('div', {
    staticClass: "size"
  }, [_c('h4', [_vm._v("选择尺寸")]), _c('ul', _vm._l(_vm.sizeList, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.sizeCurrentIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectSize(item, index);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0), _c('h4', [_vm._v("打印张数")]), _c('div', {
    staticClass: "number"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.orderNum,
      expression: "orderNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入打印张数",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    domProps: {
      "value": _vm.orderNum
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.orderNum = $event.target.value;
      }
    }
  }), _vm._v("张 ")])]), _c('div', {
    staticClass: "dialogfooter"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };